import {
  getDataSession,
  LOCAL_STORAGE,
  removeDataSession,
  setDataSession,
} from "./session";
import jwtDecode from "jwt-decode";
import moment from "moment";

export const setUserSession = (data) => {
  if (data) {
    setDataSession(LOCAL_STORAGE, "user", data);
  }
};

export const getUserSession = (key = "") => {
  const user = getDataSession(LOCAL_STORAGE, "user") || {};
  // eslint-disable-next-line no-prototype-builtins
  if (key) {
    return user.hasOwnProperty("data") ? user.data?.[`${key}`] : null;
  }
  return user;
};

export const setCmsToken = (data) => {
  setDataSession(LOCAL_STORAGE, "core_cms_token", data);
};

export const removeCmsToken = (data) => {
  removeDataSession(LOCAL_STORAGE, "core_cms_token");
};

export const getCmsToken = () => {
  return getDataSession(LOCAL_STORAGE, "core_cms_token") || {};
};

export const getCmsTokenData = () => {
  return getDataSession(LOCAL_STORAGE, "core_cms_token_data") || {};
};

export const isAuthTokenValid = () => {
  const cmsToken = getCmsToken();
  // console.log("cmsToken", cmsToken);
  // console.log("cmsToken", accessTokenData);
  let accessTokenData = jwtDecode(cmsToken?.access_token);
  if (!accessTokenData) return false;
  const currentTime = moment();
  const expiredTime = moment.unix(accessTokenData.exp);
  return currentTime.isBefore(expiredTime);
};

export const isUserLogin = () => {
  return Boolean(getUserSession("id"));
};
